import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { DialogActions, Accordion, AccordionSummary, AccordionDetails, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import api from '../services/api';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import LoadingShort from '../load/loadingShort';
import BuscaEstabelecimento from './buscaEstabelecimento';
import CloseIcon from '@mui/icons-material/Close';
import MessageState from '../messages/messageState';
import MenuNavBar from './menuNavBar';
import { navegacaoBar } from '../constants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AlertaFarmacovigilancia from '../pages/alertaFarmacovigilancia';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));

function NavBar() {
    const [open, setOpen] = React.useState(false);
    const agendaSelected = useSelector(state => state.agenda.data)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [load, setLoad] = React.useState(false);
    const { agendaId } = useParams()
    const url = useLocation();
    const [logo, setLogo] = React.useState(true);
    const [logoSize, setLogoSize] = React.useState(90);
    const [openMenu, setOpenMenu] = React.useState(false);

    const [expandedAccordion, setExpandedAccordion] = React.useState(null);


    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : null);
    };
    const handleCloseMenu = () => {
        setOpenMenu(false);
        setLogoSize(100);  // Reset logo size when closing menu
        setLogo(true)
    };

    const handleNavMenu = () => {
        setOpenMenu(!openMenu);
        setLogo(!logo)
        //setLogoSize(openMenu ? 100 : 50);
    };

    // COMTROLE DE AGENDA SELECIONADA, SE NAO FOR CONCULIDO O CADASTRO DO ESTABELECIMENTO DEVE DISPONIBILIZAR NOVAMENTE A AGENDA
    React.useEffect(() => {
        (agendaSelected?.status === 'Ocupado' && !url?.pathname.includes('licenciamento')) && setOpen(true)
    }, [agendaId, agendaSelected?.status, url?.pathname])

    const removeAgenda = () => {
        setLoad(true)
        api.patch(`/agenda/change-status`, { agendaId: agendaSelected?._id, status: 'Disponível' })
            .then(response => {
                // console.log(response)
                localStorage.removeItem(agendaId);
                dispatch({
                    type: 'agenda',
                    payload: { agenda: null }
                })

                setLoad(false)
                setOpen(false);
                // navigate('/')
            }).catch(error => '')
    }

    return (
        <>
            <AppBar position="fixed" style={{ background: '#85287e', boxShadow: 'none', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

                <Box onClick={() => navigate('/')} style={{ heigth: '100%', background: '#fffffff8', padding: '10px 25px', cursor: 'pointer', display: logo ? '' : 'none' }} >
                    <img src="/img/logo/logoArmed.svg" alt="" width={120} />
                </Box>

                <Container maxWidth="xl" style={{ padding: 0 }}>
                    {/* ALERTES DE FARMACOVIGILANCIA */}
                    <AlertaFarmacovigilancia />

                    <Toolbar disableGutters>

                        <Box minWidth={1050} alignItems={'center'} justifyContent={'center'} sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

                            {navegacaoBar.map((page, index) => (
                                <React.Fragment key={page.page}>
                                    <MenuNavBar page={page} />

                                    {index < navegacaoBar.length - 1 &&
                                        <span style={{ color: '#eaa925', margin: 3 }}>|</span>
                                    }
                                </React.Fragment>
                            ))}
                        </Box>

                        <Box sx={{ display: { xs: 'flex', md: 'none', flexGrow: 1, } }} />


                        <BuscaEstabelecimento />

                        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleNavMenu}
                                color="inherit"
                            >
                                {openMenu ? <CloseIcon /> : <MenuIcon />}
                            </IconButton>
                        </Box>

                    </Toolbar>

                    {openMenu && (
                        <Box sx={{ flexDirection: 'column', display: { xs: 'flex', md: 'none' } }}>
                            {navegacaoBar.map((item) => (
                                <Accordion
                                    key={item.page}
                                    expanded={expandedAccordion === item.page}
                                    onChange={handleAccordionChange(item.page)}
                                    sx={{ backgroundColor: 'transparent !important', color: '#fff' }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography variant='subtitle1' sx={{ marginLeft: 1, color: '#fff' }}>{item.page}</Typography>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ backgroundColor: 'transparent !important', overflow:'scroll' }}>

                                        {item.menuItens.map((subItem) => (
                                            <MenuItem key={subItem.page} sx={{ color: '#fff' }} onClick={() => { navigate(subItem.link); handleCloseMenu() }}>
                                                {subItem.page}
                                            </MenuItem>
                                        ))}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Box>
                    )}

                </Container>

            </AppBar>

            {/* MODAL DE CONTROLO DE LICENCIAMENTO EM ANDAMENTO */}
            <BootstrapDialog
                scroll='body'
                fullWidth
                // onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <div style={{ padding: 20 }}>
                    <Typography textAlign="center" marginBottom={4}>
                        <WarningAmberOutlinedIcon fontSize='large' color='warning' />
                        <br />
                        Tens um processo licenciamento de estabelecimento em andamento, deseja continuar ou cancelar?
                    </Typography>

                    <DialogActions>
                        <Button onClick={() => { navigate(`/licenciamento/${agendaSelected?._id}`); setOpen(false) }} variant="contained" style={{ background: '#85287e' }} >
                            Continuar
                        </Button>
                        <Button onClick={removeAgenda} variant="contained" color='error' >
                            {load
                                ? <LoadingShort />
                                : 'Cancelar'
                            }
                        </Button>
                    </DialogActions>
                </div>
            </BootstrapDialog>

            {/* MESSAGENS DE NOTIFICACOES */}
            <MessageState />
        </>
    );
}
export default NavBar;
